import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <ToggleButtonGroup
      value={i18n.language?.substring(0, 2)}
      exclusive
      size="small"
      onChange={(_, lang) => lang && i18n.changeLanguage(lang)}
    >
      <ToggleButton value="en">EN</ToggleButton>
      <ToggleButton value="zh">中文</ToggleButton>
    </ToggleButtonGroup>
  );
}
